import React, { useState, useEffect } from 'react';
import { Box, Typography, Breadcrumbs, Button, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { sendContactusEmail } from 'src/config/firebase';
import { Link, useParams } from 'react-router-dom';
import {SectionTitle} from '../components/SectionTitle';
import Header from '../components/Header';
import useRTL from 'src/hooks/useRTL';
import { CircularProgress, Backdrop } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import SocialIcons from '../../shared/components/SocialIcons';
import { useCompanyData } from '../../shared/contexts/DataContext';
import Map from '../../shared/components/Map';
import { contactImage } from '../../shared/logic/imagesFns';
import AddressIcon from 'src/assets/images/templates/contactus/address.svg';
import { AlertMessage } from 'src/screens/Partners/Service/components';
import PhoneIcon from 'src/assets/images/templates/contactus/phone.svg';
import EmailIcon from 'src/assets/images/templates/contactus/email.svg';

const ColorCircularProgress = withStyles({
  root: {
    color: '#0F467A',
  },
})(CircularProgress);

const useStyles = makeStyles(() => ({
  myLabel: {
    color: '#15476D',
    opacity: '0.6',
    transform: 'translate(14px, 14px) scale(1)', // Centered position
    transition: 'transform 0.2s ease-out, font-size 0.2s ease-out', // Smooth transition
    '&.Mui-focused': {
      transform: 'translate(14px, -6px) scale(0.75)', // Move label up and shrink
      fontWeight: 'bold',
      color: '#0A0945 !important',
    },
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)', // Shrink when value is present
    },
  },

  breadWhite:{
    color:'#fff',
    fontSize:'1.3rem'
  },

  iconDiv:{
    width:'63px',
    height:'63px',

    '& img':{
      width:'100%',
      height:'100%'
    }
  },

  backdrop: {
    zIndex: 111125,
    color: '#fff',
  },
}));

const Contact = () => {
  const { data } = useCompanyData();
  const [, isRTL, fontFamily] = useRTL('',"Playfair Display, serif");
  const classes = useStyles();
  const { facebookPage, instagramPage, twitterPage, description, phoneNumber, address, city, latitude, longitude } =
    data.companyData || {};
  const { t } = data || {};

  // const { id } = useParams();
  // const visibleSocialMedia = data.socialMedia;
  // const visiblePhone = data.phone;
  const visibleMap = latitude && longitude;

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[])

  return (
    <div>
      <SimpleHeader 
        {...{
          data,
          title: t && t('companyPage.contact')
        }}
      />
      {/* <Header image={contactImage(data)} 
      data={data}
      height="500px"
      title={t && t('companyPage.contactus')}
      transparencyColor={'#15476db2'}
      bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
      displayBanner={data.displayBanner}
      titleColor="#ffffff"
      >
        <Breadcrumbs aria-label="breadcrumb" style={{fontFamily:data?.fontFamily}} classes={{separator:classes.breadWhite,li:classes.breadWhite}}>
          <Link to={companyDomain ? '/' : `/${id}`}>
            {t && t('companyPage.home')}
          </Link>
          <Typography style={{color:'#17c799',fontSize:'1.2rem'}}>{t && t('companyPage.contact')}</Typography>
        </Breadcrumbs>
      </Header> */}
      <Details
        facebookPage={facebookPage}
        instagramPage={instagramPage}
        twitterPage={twitterPage}
        address={`${address} ${city}`}
        phoneNumber={phoneNumber}
        fontFamily={fontFamily}
        t={t}
        isRTL={isRTL}
        description={description}
        data={data}
        {...{visibleMap}}
      />
      { visibleMap ? <Location companyData={data.companyData} /> : null }
    </div>
  );
};

function SimpleHeader({data, title}){
  const classes = useStyles();
  const { t, companyDomain, displayBanner=true } = data || {};
  const { id } = useParams();

  return(
    <Header image={contactImage(data)} 
      data={data}
      height="500px"
      title={title}
      transparencyColor={'#15476db2'}
      bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
      displayBanner={displayBanner}
      titleColor="#ffffff"
      >
        <Breadcrumbs aria-label="breadcrumb" style={{fontFamily:data?.fontFamily}} classes={{separator:classes.breadWhite,li:classes.breadWhite}}>
          <Link to={companyDomain ? '/' : `/${id}`}>
            {t && t('companyPage.home')}
          </Link>
          <Typography style={{color:'#17c799',fontSize:'1.2rem',textTransform:'capitalize'}}>{title}</Typography>
        </Breadcrumbs>
    </Header>
  )
}

const Details = ({
  facebookPage,
  instagramPage,
  twitterPage,
  address,
  phoneNumber,
  fontFamily,
  visibleMap,
  t,
  isRTL,
  description,
  data
}) => {
  const { email } = data?.companyData || {};

  const classes = useStyles();

  const [message,setMessage] = useState('');
  const [alertType,setAlertType] = useState('');
  const [openAlert,setAlert] = useState(false);
  const [loading,setLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName:'',
    email: '',
    phone: '',
    subject: '',
    content: '',
  });

  const showAlert = (message,alertType) => {
    setMessage(message);
    setAlertType(alertType);
    setAlert(true);
  };

  const closeAlert = () => {
    setMessage('');
    setAlertType('');
    setAlert(false);
  };


  const sendEmail = () => {

    if(!formData?.firstName) {
      showAlert('Please enter first Name','error')
    }
    else if(!formData?.lastName) {
      showAlert('Please enter last Name','error')
    }
    else if(!formData?.email) {
      showAlert('Please enter valid email','error')
    }
    else if(!formData?.phone) {
      showAlert('Please enter valid phone number','error')
    }
    else if(!formData?.subject) {
      showAlert('Please enter message title','error')
    }
    else if(!formData?.content) {
      showAlert('Please enter message','error')
    }
    else{
      setLoading(true);
      const dataObj = { 
        name: `${formData?.firstName} ${formData?.lastName}`,
        ...formData,
        companyId: data?.companyData?.id
      }

      sendContactusEmail(dataObj)
      .then(msg=> {
        setLoading(false);
        setFormData({
          firstName: '',
          lastName:'',
          email: '',
          phone: '',
          subject: '',
          content: '',
        });
        showAlert('your message has been sent!','success')
      })
      .catch(errMsg=> {
        setLoading(false);
        showAlert(errMsg,'success')
      })
    }
  };

  const contactList = [
    {enable:address,icon:AddressIcon,label:'address',text: address},
    {enable:phoneNumber,icon:PhoneIcon,label:'phone',text: phoneNumber,anchorTag:true, direction:'ltr',hrefLink:`tel:${phoneNumber}`},
    {enable:email,icon:EmailIcon,label:'email',text: email,anchorTag:true,hrefLink:`mailto:${email}`},
  ]

  return (
    <Box
      width="90%"
      m="auto"
      py={5}
      display="flex"
      justifyContent="space-between"
      flexWrap="wrap"
      mt="100px"
    >
      <Box width={{ xs: '100%', md: '40%' }}>
        <SectionTitle pb={4}>{t && t('companyPage.contactus')}</SectionTitle>
        {/* <Box pb={2}>
          <Typography variant="body1" style={{fontFamily:data?.fontFamily,fontSize:'1.2rem'}}>{description}</Typography>
        </Box> */}

          {React.Children.toArray(contactList.filter(val => val.enable).map(v=> {
            return(
              <Box 
                display="flex"
                flexDirection="row"
                alignItems="center"
                pb={2}
              >
                {v?.anchorTag ?
                  <a href={v.hrefLink}>
                    <Box className={classes.iconDiv}>
                      <img src={v.icon} alt={v.label} />
                    </Box>
                  </a>
                :
                <Box>
                <Box className={classes.iconDiv}>
                  <img src={v.icon} alt={v.label} />
                </Box>
                </Box>
                }
                <Box px="20px">
                  {v?.anchorTag ?
                    <a href={v.hrefLink}>
                      <Typography variant="body1" style={{color:"#15476D",fontFamily:data?.fontFamily,fontSize:'1.2rem',fontWeight:'bold'}}>{v?.text}</Typography>
                    </a>
                  :
                    <Typography variant="body1" style={{color:"#15476D",fontFamily:data?.fontFamily,fontSize:'1.2rem',fontWeight:'bold'}}>{v?.text}</Typography>
                  }
                </Box>
              </Box>
              )
          }))}


        {/* {address && visibleMap ?
        <Box pb={2}>
          <Typography variant="body1" style={{color:"#15476D",fontFamily:data?.fontFamily,fontSize:'1.2rem',fontWeight:'bold'}}>{address}</Typography>
        </Box>
        : null } */}

        {/* {phoneNumber ?
        <Box pb={2}>
          <Typography variant="body1" style={{color:"#15476D",fontFamily:data?.fontFamily,fontSize:'1.2rem',fontWeight:'bold'}}>{phoneNumber}</Typography>
        </Box>
        : null }

        {email ?
          <Box pb={2}>
            <Typography variant="body1" style={{color:"#15476D",fontFamily:data?.fontFamily,fontSize:'1.2rem',fontWeight:'bold'}}>{email}</Typography>
          </Box>
        : null } */}

        {(facebookPage || instagramPage || twitterPage) && (
          <Box py={5}>
            <SectionTitle pb={2}>{t && t('companyPage.followUs')}</SectionTitle>
            <SocialIcons
              pb={3}
              color="#15476D"
              bgcolor="#fafafa"
              border="1px solid #DEDEDE"
              mb={2}
              facebookLink={facebookPage}
              instagramLink={instagramPage}
              twitterLink={twitterPage}
            />
          </Box>
        )}
      </Box>
      <Box width={{ xs: '100%', md: '50%' }}>
        <SectionTitle pb={4}>{t && t('companyPage.getInTouch')}</SectionTitle>
        <Box>
          <Box
            pb={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box width="45%">
              <TextField
                InputLabelProps={{ className: classes.myLabel }}
                fullWidth
                variant="outlined"
                id="firstName"
                label={t && t("profile-comp.first")}
                value={formData.firstName}
                onChange={(e) =>
                  setFormData({ ...formData, firstName: e.target.value })
                }
              />
            </Box>

            <Box width="45%">
              <TextField
                InputLabelProps={{ className: classes.myLabel }}
                fullWidth
                variant="outlined"
                id="lastName"
                label={t && t("profile-comp.last")}
                value={formData.lastName}
                onChange={(e) =>
                  setFormData({ ...formData, lastName: e.target.value })
                }
              />
            </Box>
          </Box>

          <Box
            pb={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box width="45%">
              <TextField
                InputLabelProps={{ className: classes.myLabel }}
                fullWidth
                variant="outlined"
                id="email"
                label={t && t('reservations.email')}
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
            </Box>

            <Box width="45%">
              <TextField
                InputLabelProps={{ className: classes.myLabel }}
                fullWidth
                variant="outlined"
                id="phone"
                label={t && t('reservations.phoneNumber')}
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
              />
            </Box>
          </Box>

          <Box pb={2}>
            <TextField
              InputLabelProps={{ className: classes.myLabel }}
              fullWidth
              variant="outlined"
              id="subject"
              label="Message Title"
              value={formData.subject}
              onChange={(e) =>
                setFormData({ ...formData, subject: e.target.value })
              }
            />
          </Box>
          <Box pb={2}>
            <TextField
              InputLabelProps={{ className: classes.myLabel }}
              multiline
              rows={8}
              fullWidth
              variant="outlined"
              id="content"
              label="Message"
              value={formData.content}
              onChange={(e) =>
                setFormData({ ...formData, content: e.target.value })
              }
            />
          </Box>
        </Box>
        <Box textAlign={isRTL === 'ar' ? 'left' : "right"}>
            <Button size="large" variant="contained" color="primary" onClick={sendEmail} style={{fontFamily:data?.fontFamily}}>
              {t && t('companyPage.send')}
            </Button>
        </Box>
      </Box>

      <AlertMessage
        {...{
            alertType,message,snackOpen:openAlert,
            closeAlert
        }}
      />

      <Backdrop className={classes.backdrop} open={loading}>
        <ColorCircularProgress />
      </Backdrop>
    </Box>
  );
};

const Location = ({ companyData }) => {
  return (
    <Box pb={4} height="400px" width="90%" m="auto" mb="100px">
      <Map
        longitude={companyData?.longitude}
        latitude={companyData?.latitude}
      />
    </Box>
  );
};

export default Contact;

export {
  SimpleHeader
};